import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeDecimalPoints'
})
export class RemoveDecimalPointsPipe implements PipeTransform {

  transform(value: number, decimalPlaces: number = 2): string {
    if (typeof value !== 'number' || typeof decimalPlaces !== 'number') {
      throw new Error('Both value and decimalPlaces must be numbers');
    }
    return value.toFixed(decimalPlaces);  
  }

}
